import { core, safeEnumCompare } from '@tock/coretypes';
import Anchor from 'components/Anchor';
import React from 'react';
import protos from 'utils/protos';

const { LoyaltyProgramConsumerTheme } = protos;

export interface LoyaltyProgramDetails {
  businessName: string;
  connectText?: string;
  clubName: string;
  disableLogin?: boolean;
  learnMoreUrl?: string;
  learnMoreElement?: React.ReactNode;
  logoUrl?: string;
  pointsName: string;
  programName: string;
  showDollarSign?: boolean;
}

const LEYE: LoyaltyProgramDetails = {
  programName: 'Lettuce Entertain You Frequent Diner Club',
  businessName: 'Lettuce Entertain You',
  connectText:
    'Use your Reward Dollars from the Lettuce Entertain You Frequent Diner Club towards your purchase.',
  learnMoreUrl: 'https://www.leye.com/mobile-app/',
  logoUrl: 'https://storage.googleapis.com/tock-public-assets/images-logo/leye-logo-small.png',
  pointsName: 'Frequent Diner Points',
  clubName: 'Club',
};

const TAO_GROUP: LoyaltyProgramDetails = {
  programName: 'Tao Group Hospitality Rewards',
  businessName: 'Tao Group Hospitality',
  connectText:
    'Connect your Tao Group Hospitality Rewards account to earn points on your purchase.',
  learnMoreUrl: 'https://taogroup.com/rewards',
  logoUrl: 'https://storage.googleapis.com/tock-public-assets/images-logo/tao.png',
  pointsName: 'Rewards Points',
  clubName: 'Rewards',
};

const FABIO_TRABOCCHI_GROUP: LoyaltyProgramDetails = {
  programName: 'Fabio Trabocchi Restaurants VIP Club',
  businessName: 'Fabio Trabocchi Restaurants',
  connectText: 'Earn points for VIP member benefits with this purchase.',
  learnMoreElement: (
    <>
      Not a member? Email{' '}
      <Anchor
        className="ConsumerCheckout-loyaltyProgram--join"
        href="mailto:vipmember@fabiotrabocchi.com"
        target="_blank"
      >
        vipmember@fabiotrabocchi.com
      </Anchor>{' '}
      for more information.
    </>
  ),
  logoUrl: 'https://storage.googleapis.com/tock-public-assets/images-logo/ft_small.png',
  pointsName: 'Rewards Points',
  clubName: 'Rewards',
};

const FOLEY_GROUP: LoyaltyProgramDetails = {
  programName: 'Foley Food & Wine Society Loyalty Program',
  businessName: 'Foley Family Wines',
  learnMoreUrl: 'https://shop.foleyfoodandwinesociety.com/About-Us/Society-Loyalty-Points-Program',
  logoUrl: 'https://storage.googleapis.com/tock-public-assets/images-logo/foley.png',
  pointsName: 'Rewards Points',
  clubName: 'Rewards program',
  disableLogin: true,
  showDollarSign: true,
};

export function getLoyaltyProgramDetails(
  theme?: core.LoyaltyProgramConsumerTheme
): LoyaltyProgramDetails {
  if (safeEnumCompare(theme, LoyaltyProgramConsumerTheme, LoyaltyProgramConsumerTheme.TAO_GROUP)) {
    return TAO_GROUP;
  }
  if (
    safeEnumCompare(
      theme,
      LoyaltyProgramConsumerTheme,
      LoyaltyProgramConsumerTheme.FABIO_TRABOCCHI_GROUP
    )
  ) {
    return FABIO_TRABOCCHI_GROUP;
  }
  if (
    safeEnumCompare(
      theme,
      LoyaltyProgramConsumerTheme,
      LoyaltyProgramConsumerTheme.ANNEX_CLOUD_DEFAULT
    )
  ) {
    return FOLEY_GROUP;
  }
  return LEYE;
}
